import type { ComponentProps } from "react"
import type { ClerkProvider } from "@clerk/react"

type Appearance = NonNullable<ComponentProps<typeof ClerkProvider>["appearance"]>

/**
 * Single source of Clerk theming. Every colour is a NIRA CSS variable, so the
 * light/dark switch (nira-theme.css) restyles Clerk with no JS involved.
 */
export const clerkAppearance: Appearance = {
  options: { unsafe_disableDevelopmentModeWarnings: true },
  variables: {
    colorPrimary: "var(--nira-accent)",
    colorBackground: "var(--nira-surface)",
    colorInput: "var(--nira-bg)",
    colorInputForeground: "var(--nira-text)",
    colorForeground: "var(--nira-text)",
    colorMutedForeground: "var(--nira-text-2)",
    colorPrimaryForeground: "var(--nira-accent-ink)",
    colorNeutral: "var(--nira-text)",
    colorDanger: "var(--nira-upheld)",
    colorSuccess: "var(--nira-good)",
    colorWarning: "var(--nira-warn)",
    colorShimmer: "var(--nira-wash)",
    fontFamily: "var(--nira-font-body)",
    fontFamilyButtons: "var(--nira-font-body)",
    borderRadius: "var(--nira-radius-cite)",
    fontSize: "0.9375rem",
  },
  elements: {
    cardBox: { boxShadow: "var(--nira-shadow)", border: "1px solid var(--nira-border)" },
    headerTitle: { fontFamily: "var(--nira-font-head)", fontWeight: 600 },
    formButtonPrimary: { boxShadow: "none" },
    footer: { background: "transparent" },
    avatarBox: { width: "2rem", height: "2rem" },
    userButtonPopoverCard: { border: "1px solid var(--nira-border)", boxShadow: "var(--nira-shadow)" },
  },
}
